module.exports = __webpack_public_path__ + "img/113.861776d1.jpg";